// Import model
import { StartContactAddTaskRequest } from '../models/StartContactAddTaskRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartContactAddTaskRequest - handles JSON serialization and deserialization with type validation
 */
export class StartContactAddTaskRequestSerializer {
  /**
   * Deserializes a JSON string into a StartContactAddTaskRequest instance
   */
  static deserialize(json: string): StartContactAddTaskRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartContactAddTaskRequest instance
   */
  static fromObject(obj: any): StartContactAddTaskRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartContactAddTaskRequest');
    }


    const instance: StartContactAddTaskRequest = {
      dueDate: obj['DueDate'] as string | undefined,
      priority: obj['Priority'] as string | undefined,
      name: obj['Name'] as string | undefined,
      content: obj['Content'] as string | undefined,
      assignedUserId: obj['AssignedUserId'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartContactAddTaskRequest instances
   */
  static deserializeArray(json: string): StartContactAddTaskRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartContactAddTaskRequest instance to a JSON string
   */
  static serialize(instance: StartContactAddTaskRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartContactAddTaskRequest instance to a plain object
   */
  static toObject(instance: StartContactAddTaskRequest): any {
    return {
      'DueDate': instance.dueDate,
      'Priority': instance.priority,
      'Name': instance.name,
      'Content': instance.content,
      'AssignedUserId': instance.assignedUserId,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartContactAddTaskRequest instances to a JSON string
   */
  static serializeArray(instances: StartContactAddTaskRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
